import { Concessao } from "@tivic-team/manager-ts/dist/mob/entities/concessao/concessao.entity";
import { ConcessaoColetivoUrbanoDTO, ConcessaoColetivoUrbanoDTOList } from "app/model/dtos/mob/concessao-coletivo-urbano.dto";
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environmentv3 } from "src/environments/environmentv3";
import { ApiController } from "../api-controller.interface";

export class ConcessaoColetivoUrbanoController implements ApiController<ConcessaoColetivoUrbanoDTO>{
    
    get(cdConcessionario: number): Promise<ConcessaoColetivoUrbanoDTO> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/concessaocoletivourbano/concessionario/:cdConcessionario',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdConcessionario: cdConcessionario
                    }),
                }),
            }),
            new HttpResponse(new ConcessaoColetivoUrbanoDTO())
        );
        return request.call();
    }
   
    find(filters?: IFilter): Promise<ConcessaoColetivoUrbanoDTO[]> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/concessaocoletivourbano/concessionario',
                    environment: environmentv3,
                    filter: filters
                }),
            }),
            new HttpResponse(new Array<ConcessaoColetivoUrbanoDTO>())
        );

        return request.call();
    }
    
    findPermissoes(filters? : IFilter): Promise<ConcessaoColetivoUrbanoDTOList> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/concessaocoletivourbano',
                    environment: environmentv3,
                    filter: filters
                }),
            }),
            new HttpResponse(new ConcessaoColetivoUrbanoDTOList())
        );

        return request.call();
    }

    getConcessao(id: number): Promise <ConcessaoColetivoUrbanoDTO> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/concessaocoletivourbano/:cdConcessao',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdConcessao: id
                    }),
                }),
            }),
            new HttpResponse(new ConcessaoColetivoUrbanoDTO())
    );

        return request.call();
    }

    getPermissionarios(filters? : IFilter): Promise <ConcessaoColetivoUrbanoDTO[]> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/concessaocoletivourbano/permissionarios',
                    environment: environmentv3,
                    filter: filters
                }),
            }),
            new HttpResponse(new Array<ConcessaoColetivoUrbanoDTO>())
    );

        return request.call();
    }

    create(entity: ConcessaoColetivoUrbanoDTO): Promise <ConcessaoColetivoUrbanoDTO> {
        let request = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/concessaocoletivourbano',
                    environment: environmentv3
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse( new ConcessaoColetivoUrbanoDTO())
        );

        return request.call();
    }

    update(entity: ConcessaoColetivoUrbanoDTO): Promise <ConcessaoColetivoUrbanoDTO> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/concessaocoletivourbano/:cdConcessao',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdConcessao: entity.cdConcessao
                    })
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse( new ConcessaoColetivoUrbanoDTO())
        );
        return request.call();
    }

    ativar(entity: ConcessaoColetivoUrbanoDTO): Promise<ConcessaoColetivoUrbanoDTO> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/concessaocoletivourbano/:cdConcessao/ativar',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdConcessao: entity.cdConcessao
                    })
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse( new ConcessaoColetivoUrbanoDTO())
        );
        return request.call();  

    }

    desativar(entity: ConcessaoColetivoUrbanoDTO): Promise<ConcessaoColetivoUrbanoDTO> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/concessaocoletivourbano/:cdConcessao/inativar',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdConcessao: entity.cdConcessao
                    })
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse( new ConcessaoColetivoUrbanoDTO())
        );
        return request.call();  
    }

    async getConcessaoByConcessionario(cdConcessionario: number): Promise<Concessao> {
        let quark = new Quark(
          new HttpGet({
          url: new Url({
            id: "mob/concessaocoletivourbano/concessao/:cdConcessionario",
            environment: environmentv3,
            pathParams: new JSONData({ cdConcessionario: cdConcessionario }),
          }),
        }),
          new HttpResponse(new Concessao())
        );
        return await quark.call();
    }
}